type Props = {
  currentQuestion: any;
};

const CalculatedField = ({ currentQuestion }: Props) => {
  const { responses } = currentQuestion;

  return (
    <div style={{ fontSize: "14px" }}>
      {responses?.[0]?.textValue ?? responses?.[0]?.numberValue ?? ""}
    </div>
  );
};
export default CalculatedField;
